export default {
  fatalErrorMessageLabel: 'Something went wrong.',
  fatalErrorMessageLong: 'Something went wrong, please let Hatfield know so we can fix this.',
}
